





























import {Component, Prop, Vue} from 'vue-property-decorator'
import {FlamingoOrderBook} from '@/libs/flamingo-orderbook/FlamingoOrderbook'

@Component
export default class SwapErrorBox extends Vue {
  @Prop({type: Boolean, required: true}) isInputRequired!: boolean
  @Prop({type: Boolean, required: true}) isAmountToUseInvalid!: boolean
  @Prop({type: Boolean, required: true}) isAmountToReceiveInvalid!: boolean
  @Prop({type: Boolean, required: true}) isSlippageHigh!: boolean
  @Prop({type: Boolean, required: true}) isMaxValueExceeded!: boolean
  @Prop({type: String, required: true}) tokenToReceiveSymbol!: string

  get isWarning() {
    return this.isSlippageHigh
  }

  get errorMessage(): {title: string; text: string} | null {
    const t = this.$translate

    const messages: Record<string, () => {title: string; text: string}> = {
      inputRequired: () => {
        const tokensAvailableToUse = FlamingoOrderBook.listSwappableTokens()
          .filter(token => token !== this.tokenToReceiveSymbol)
          .join(', ')

        return {
          title: t('components.SwapErrorBox.inputRequiredTitle'),
          text: t('components.SwapErrorBox.unavailableOptionsMessage', {
            tokensAvailableToUse,
          }),
        }
      },
      amountInvalid: () => ({
        title: t('components.SwapErrorBox.errorTitle'),
        text: t('components.SwapErrorBox.enterValueMessage'),
      }),
      maxExceeded: () => ({
        title: t('components.SwapErrorBox.errorTitle'),
        text: t('components.SwapErrorBox.maxValueExceededMessage'),
      }),
      slippageHigh: () => ({
        title: t('components.SwapErrorBox.warningTitle'),
        text: t('components.SwapErrorBox.slippageHighMessage'),
      }),
    }

    if (this.isInputRequired) return messages.inputRequired()
    if (this.isAmountToUseInvalid || this.isAmountToReceiveInvalid)
      return messages.amountInvalid()
    if (this.isMaxValueExceeded) return messages.maxExceeded()
    if (this.isSlippageHigh) return messages.slippageHigh()

    return null
  }
}
